import { trpc } from '@/shared/api';

/** 기획전 목적 목록(어드민) — 배열 순서가 고객 기획전 페이지의 탭 순서다. */
export const useExhibitionPurposesQuery = () =>
  trpc.productManagement.exhibitionPurposes.list.useQuery();
